/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useEffect, useState } from "react"
import { LidarPropertiesObject, LidarPropertiesTableRow, LidarPropsKeyToTitleMap } from "../../constants"
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import ArgosMenuItem from "../../../../../components/Form/Select/ArgosMenuItem";
import ArgosSelect from "../../../../../components/Form/Select/ArgosSelect";

import {ArgosTableSimple} from "../../../../../components/Table/ArgosTableSimple";

interface ILidarPropertiesProps{
  sensorLidarData: any
  isDialogOpen: boolean
  handleTempChange: any
  baselineData: any
  temperatureArray: number[]
}


const LidarProperties = (props: ILidarPropertiesProps) => {
  const [rowsData, setRowsData] = useState<LidarPropertiesTableRow[]>([]);
  
  useEffect(() => {
    mapPropsToRowFormat()
  }, [props])

  const LidarPropertiesTableColumns: MRT_ColumnDef<LidarPropertiesTableRow>[] = [
    {
      header: "Name",
      accessorKey: "propertyName",
      enableEditing: false,
      minSize: 250,
    },
    {
      header: "Value",
      accessorKey: "propertyValue",
      enableEditing: true,
      Cell: ({ cell }) => {
          return <div>{cell.getValue() as any}</div>
      }
    },
    {
      header: "Unit",
      accessorKey: "unit",
      enableEditing: false,
    },
  ]

  /**
   * Intrumentation limits are inside the plot_data subobject so break the key down and access the value
   * @param propertyObject 
   * @returns 
   */
  const getValueIfKeyIsComposed = (propertyObject : LidarPropertiesObject)=> {
    let compositeKey: string[] = []
    let _key: string = propertyObject.key;
    let compositeValue: any = ""
    if(_key.includes(".")){
      compositeKey = compositeKey.concat(_key.split("."))
      compositeKey.forEach((keySection: string) => {
        if(compositeValue == ""){
          compositeValue = props?.sensorLidarData[keySection]
        }
        else{
          compositeValue = compositeValue?.[keySection]
        }
      })
    }
    return compositeValue
  } 

 
  const mapPropsToRowFormat = () => {
    let  _rowsData: LidarPropertiesTableRow[] = []
    LidarPropsKeyToTitleMap.forEach((propertyObject: LidarPropertiesObject) => {
      let _key: string = propertyObject.key;
      // get value from supbject if property is one of the instrumentation limits
      let compositeValue = getValueIfKeyIsComposed(propertyObject);
      let _propertyValue = compositeValue == "" ? props?.sensorLidarData[_key] : compositeValue
      let rowObject: LidarPropertiesTableRow = {
        propertyName: propertyObject.label,
        unit: propertyObject.unit,
        propertyValue: _propertyValue
      }
      _rowsData.push(rowObject)
    })
    setRowsData(_rowsData)
  }

  return (
      <div style={{padding: "5px"}}>
        <ArgosTableSimple 
          columns={LidarPropertiesTableColumns}
          data={rowsData}

          initialState={{density: 'compact'}}
          enablePagination={false}
          enableBottomToolbar={false}
        />
      </div>
  )
}

export default LidarProperties